export default {
    methods: {
        /**
         * In dark mode?
         *
         * @return {Boolean}
         */
        inDarkMode() {
            return true
        },
    }
}
